import type { OfflineFile } from "../offlineFiles.store";

const returnPWD = (file: OfflineFile, folderNames: Map<string, string>) => {
  let path = "";

  const parentsIds = [
    ...((file.file.files_by_pk?.folder.parents_ids ?? []) as string[]),
    file.file?.files_by_pk?.parent_id ?? "",
  ];

  parentsIds.forEach((parentId) => {
    const folderName = folderNames.get(parentId);
    if (folderName) {
      path += `/${folderName}`;
    }
  });

  return path;
};

export { returnPWD };
